import { memoize } from 'lodash';
import { createSelector } from 'reselect';
import { State } from '.';
import { ICD10 } from '../../models/icd10';

const getOtherICD10IdsSelector = createSelector(
    (state: State) => state.byCode,
    (byCode: Dictionary<ICD10>) => memoize((
        codes: Undefinable<string>[]
    ) => codes.filter(x => x && !byCode[x]) as string[])
);

export const selectors = {
    checkSearched: (
        state: State,
        text: string
    ): boolean => state.searchedTextHash[text] || false,
    getICD10: (
        state: State,
        code: Undefinable<string>
    ): Undefinable<ICD10> => state.byCode[code || ''],
    getICD10Hash: (
        state: State
    ): Dictionary<ICD10> => state.byCode,
    getLoading: (
        state: State,
        loadingKey: string
    ): boolean => state.loading[loadingKey] || false,
    getLoadingHash: (
        state: State
    ): Dictionary<boolean> => state.loading,
    getOtherICD10Ids: (
        state: State,
        codes: Undefinable<string>[]
    ): string[] => getOtherICD10IdsSelector(state)(codes)
};
